<script lang="ts">
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import {
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from '../../../../../services/gen_2_http_reqs';
	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	import type { InputOutputOptions } from './input_output_types';
	//Design system compoents
	import { Button, Container, Radio, Text, toast } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device;

	const id = real_id(device.id);
	const category = get_gen_2_component_from_category(device);

	const method = `${get_gen_2_component_from_category(device)}.SetConfig`;

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	let typeValue = settings[`${category}:${device.channel}`]?.type;

	let initialStateValue =
		device.category !== 'inputs_reader'
			? settings[`${category}:${device.channel}`]?.initial_state
			: '';
	let cache = initialStateValue;
	let loading = false;

	const initial_state_options: InputOutputOptions = {
		on: {
			type: 'any',
			text: $format('init_state_on_description'),
			title: $format('init_state_on_title', { default: 'Turn on' }),
			description: $format('init_state_on_desc', {
				default: 'Automatically turns the device ON when power is restored.',
			}),
		},
		off: {
			type: 'any',
			text: $format('init_state_off_description'),
			title: $format('init_state_off_title', { default: 'Turn off' }),
			description: $format('init_state_off_desc', {
				default: 'Keeps the device OFF when power is restored.',
			}),
		},
		restore_last: {
			type: 'any',
			text: $format('init_state_report_last_description'),
			title: $format('init_state_restore_last_title', { default: 'Restore last state' }),
			description: $format('init_state_restore_last_desc', {
				default: 'Returns the device to its previous state when power is restored.',
			}),
		},
		match_input: {
			type: 'switch',
			text: $format('init_state_match_input_description'),
			title: $format('init_state_match_input_title', { default: 'Match input' }),
			description: $format('init_state_match_input_desc', {
				default:
					'Operates the device according to the state of the switch or button connected to the device.',
			}),
		},
	};

	const _initialStateOptionsScc = {
		on: $format('init_state_on_scc_toast', { default: 'on' }),
		off: $format('init_state_off_scc_toast', { default: 'off' }),
		restore_last: $format('init_state_restore_last_scc_toast', {
			default: 'restore last',
		}),
	};

	if (category === 'light') {
		delete initial_state_options.match_input;
	}
	const setInitialState = async (_initial_state_value) => {
		initialStateValue = _initial_state_value;
	};

	const sentRequest = async () => {
		if (cache !== initialStateValue) {
			loading = true;
			const params = {
				id: device.channel,
				config: { initial_state: initialStateValue },
			};

			const res: SettingRequest = await gen2Request(device, method, params);

			if (res.isok) {
				settings[
					`${get_gen_2_component_from_category(device)}:${device.channel}`
				].initial_state = initialStateValue;
				devices_settings.update_devices_settings(id, settings);

				toast.open({
					type: 'success',
					title: $format('init_state_scc_toast', {
						values: {
							initial_state_value: _initialStateOptionsScc[initialStateValue],
						},
					}),
				});
				cache = initialStateValue;
			} else {
				toast.open({ type: 'danger', title: $format('init_state_err_toast') });
				initialStateValue = cache;
			}
			loading = false;
		}
	};
</script>

{#if $showNewLayout}
	<Container padding="s" type="borderSolid" backgroundColor="color-base">
		<Text styleType="body-small">{formatSnakeCaseToTitle($format('init_state_label'))}</Text>
		{#each Object.entries(initial_state_options) as option}
			<Radio
				size="m"
				bind:selected={initialStateValue}
				value={option[0]}
				class="mb-s"
				disabled={option[1].type !== typeValue && option[1].type !== 'any'}
				on:click={() => setInitialState(option[0])}
				id="radio-bb9igs7"
				info={option[1]?.description}
			>
				{option[1]?.title}
			</Radio>
		{/each}
	</Container>
	<div class="mb-s">
		<Button class="mt-l" {loading} size="m" width="full" on:click={sentRequest}>
			{$format('button_save')}
		</Button>
	</div>
{:else}
	<Text styleType="body-small">{formatSnakeCaseToTitle($format('init_state_label'))}</Text>
	{#each Object.entries(initial_state_options) as option}
		<Radio
			size="m"
			bind:selected={initialStateValue}
			value={option[0]}
			disabled={option[1].type !== typeValue && option[1].type !== 'any'}
			on:click={() => setInitialState(option[0])}
			id="radio-bb9igs7"
		>
			{option[1]?.text}
		</Radio>
	{/each}
	<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
		{$format('button_save')}
	</Button>
{/if}
